<template>
  <vs-card class="rep">
    <table class="w-full" >
      <thead>
      <tr height="85">
        <th rowspan="2">№</th>
        <th rowspan="2">{{$t('region_names')}}</th>
        <th colspan="3">
          {{$t('all_on')}}
        </th>
        <th colspan="5">{{$t('gem')}}</th>
        <th colspan="5">{{$t('sluchay')}}</th>
      </tr>
      <tr>
        <th>{{$t('ob_ob')}}</th>
        <th>{{$t('mon')}}</th>
        <th>{{$t('pkmpo')}}</th>
        <th>{{$t('ob_ob')}}</th>
        <th>{{$t('miz_ob')}}</th>
        <th>{{$t('pkmpo2')}}</th>
        <th>
          {{$t('Кол-во Источников Загрязнения (ИЗ)')}}
        </th>
        <th>{{$t('Кол-во ИЗ по списку ПКМ №343')}}</th>
        <th>{{$t('ob_ob')}}</th>
        <th>{{$t('miz_ob')}}</th>
        <th>{{$t('pkmpo2')}}</th>
        <th>
          {{$t('Кол-во Источников Загрязнения')}}
        </th>
        <th>{{$t('Кол-во ИЗ по списку ПКМ №343')}}<br/></th>
      </tr>

      <tr>
        <td colspan="2">{{list2.region}}</td>
        <td>{{list2.total_number_of_objects}}</td>
        <td>{{list2.total_number_of_monitoring_miz}}</td>
        <td>{{list2.total_number_of_monitoring_343}}</td>
        <td>{{list2.total_number_of_objects_data}}</td>
        <td>{{list2.number_of_mon_obj_according_to_the_list}}</td>
        <td>{{list2.number_of_monitoring_pcm_list_no_343}}</td>
        <td>{{list2.number_f_pollution_sources_sp_miz}}</td>
        <td>{{list2.number_of_items_according_to_pkm_list_no_343}}</td>
        <td>{{list2.total_number_of_objects_2}}</td>
        <td>{{list2.number_of_mon_obj_according_to_the_list_2}}</td>
        <td>{{list2.total_number_of_monitoring_343_2}}</td>
        <td>{{list2.number_f_pollution_sources_sp_miz_2}}</td>
        <td>{{list2.number_of_items_according_to_pkm_list_no_343_2}}</td>
      </tr>

      <tr v-for="(item, index) in list" :key="index">
        <td>{{ index + 1 }}</td>
        <td>{{ item.region }}</td>
        <td>{{ item.total_number_of_objects }}</td>
        <td>{{ item.total_number_of_monitoring_miz }}</td>
        <td>{{ item.total_number_of_monitoring_343 }}</td>
        <td>{{ item.total_number_of_objects_data }}</td>
        <td>{{ item.number_of_mon_obj_according_to_the_list }}</td>
        <td>{{ item.number_of_monitoring_pcm_list_no_343 }}</td>
        <td>{{ item.number_f_pollution_sources_sp_miz }}</td>
        <td>{{ item.number_of_items_according_to_pkm_list_no_343 }}</td>
        <td>{{ item.total_number_of_objects_2 }}</td>
        <td>{{ item.number_of_mon_obj_according_to_the_list_2 }}</td>
        <td>{{ item.total_number_of_monitoring_343_2 }}</td>
        <td>{{ item.number_f_pollution_sources_sp_miz_2 }}</td>
        <td>{{ item.number_of_items_according_to_pkm_list_no_343_2 }}</td>
      </tr>
      </thead>
    </table>
  </vs-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      list: [],
      list2: {},
    };
  },
  computed: {
    ...mapGetters("statistics", ['getStatisticsReport'])
  },
  mounted() {
    this.refresh()
  },
  methods: {
    ...mapActions("statistics", ['fetchStatisticsReport']),

    refresh() {
      this.fetchStatisticsReport()
        .then(() => {
          this.list = this.getStatisticsReport
          let index = this.list.findIndex((elem) => {
            if (elem.region === "Все регионы") {
              return this.list2 = elem
            }
          })
          this.list.splice(index, 1)
        })
    }
  }
};
</script>

<style>
.rep table {
  border-collapse: collapse;
}

.rep table * {
  border: 1px solid #ccc;
  text-align: center;
  font-size: 1rem;
}
</style>
